import React from 'react';
import { Filters } from '@/components/organisms';

interface FundingFiltersProps {
  search: string;
  onSearchChange: (value: string) => void;
  sortBy: 'DATE' | 'PROJECT_NAME' | 'ORDERS' | '';
  onSortByChange: (value: 'DATE' | 'PROJECT_NAME' | 'ORDERS' | '') => void;
  sortDirection: 'ASC' | 'DESC' | '';
  onSortDirectionChange: (value: 'ASC' | 'DESC' | '') => void;
  className?: string;
}

const FundingFilters: React.FC<FundingFiltersProps> = ({
  search,
  onSearchChange,
  sortBy,
  onSortByChange,
  sortDirection,
  onSortDirectionChange,
  className,
}) => {
  const filterGroups = [
    {
      id: 'sortBy',
      label: 'Sort By',
      value: sortBy,
      onChange: (v: string) => onSortByChange(v as 'DATE' | 'PROJECT_NAME' | 'ORDERS' | ''),
      options: [
        { value: '', label: 'Sort By' },
        { value: 'DATE', label: 'Date' },
        { value: 'PROJECT_NAME', label: 'Project Name' },
        { value: 'ORDERS', label: 'Orders' },
      ],
    },
    {
      id: 'sortDirection',
      label: 'Sort Direction',
      value: sortDirection,
      onChange: (v: string) => onSortDirectionChange(v as 'ASC' | 'DESC' | ''),
      options: [
        { value: '', label: 'Sort Order' },
        { value: 'ASC', label: 'Ascending' },
        { value: 'DESC', label: 'Descending' },
      ],
    },
  ];

  return (
    <Filters
      searchPlaceholder="Search by project name..."
      searchValue={search}
      onSearchChange={onSearchChange}
      filterGroups={filterGroups}
      className={className}
      layout="horizontal"
    />
  );
};

export default FundingFilters; 